import type {Schemas} from 'api/dto.generated';
import type {NorafUpdate, NorafUpdates} from '../types';
import {mapAgentTypeDto} from './mapAgentTypeDto';

export const mapNorafUpdatePageResponse = (
  dto: Schemas.NorafUpdatesPageResponse,
): NorafUpdates => {
  return {
    total: dto.totalElements,
    pages: dto.totalPages,
    items: dto.items.map(mapNorafUpdate),
  };
};

export const mapNorafUpdate = (dto: Schemas.NorafUpdate): NorafUpdate => {
  return {
    ...dto,
    agentType: mapAgentTypeDto(dto.agentType),
    lastUpdated: dto.lastUpdated * 1000,
  };
};
